
import request from "@/utils/request";


// 注册
export function bindPhone(data) {
  return request({
    url: '/api/Users/bindPhone',
    method: 'post',
    data,
  })
}


//生成滑动验证码
export function getKaptchaImg(data) {
  return request({
    url: '/api/Captcha/generate',
    method: 'post', 
    data
  })
}

//滑动验证码校验
export function checkKaptchaImg(data) {
  return request({
    url: '/api/Captcha/verify',
    method: 'post', 
    data
  })
}

//发送短信验证码
export function sendMessageApi(data) {
  return request({
    url: '/api/Sms/send',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    params:data
  })
}


// 员工列表
export function getUserList(data) {
  return request({
    url: '/api/Users/page',
    method: 'post',
    data
  })
}

// 添加员工 
export function addUser(data) {
  return request({
    url: '/api/Users/addUsers',
    method: 'post',
    data
  })
}

// 编辑员工 
export function updateUser(data) {
  return request({
    url: '/api/Users/updateUsers',
    method: 'post',
    data
  })
}

//删除员工 
export function delUser(id) {
  return request({
    url: '/api/Users/delete?userId='+id,
    method: 'post',
  })
}


